/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';

import { InjectedReducersType } from 'utils/types/injector-typings';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export function createReducer(injectedReducers: InjectedReducersType = {}) {
  // Before any reducer is injected, return an identity reducer with an empty-object
  // initial state. react-redux 9's useSelector evaluates selectors eagerly on first
  // render (before injection effects run), so the root state must never be undefined.
  if (Object.keys(injectedReducers).length === 0) {
    return (state = {}) => state;
  } else {
    return combineReducers({
      ...injectedReducers,
    });
  }
}
